module.exports = __webpack_public_path__ + "img/map-pin-icon.6d883af.png";